<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-6">
                <div class="card">
                    <div class="card-header card-header-squirrel">
                        <h4 class="card-title">{{this.translate.data["SUBTITLESETTINGS"] | translate}}</h4>
                    </div> 
                    <div class="card-body">
                        <mat-form-field class="form-element">
                            <mat-label>{{this.translate.data["SELECTLANGUAGE"] | translate}} ({{this.translate.data["CURRENTSETTING"] | translate}}: {{actLang}})</mat-label>
                            <mat-select>
                                <mat-option *ngFor="let lang of appLanguages" [value]="lang.abbv" (click)="setLang(lang.abbv)">
                                    {{lang.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>                
                </div>
            </div>
            <div class="col-md-6">
                <div class="card">
                    <div class="card-header card-header-squirrel">
                        <h4 class="card-title">{{this.translate.data["SELECTCOLORTHEME"] | translate}}</h4>
                    </div>
                    <div class="card-body">
                        <div class="row p-2" style="margin: 0;">
                            <div class="col-sm-6 hover-effect" data-toggle="tooltip" data-placement="bottom"
                                title="Purple Theme" style="padding: 0;">
                                <div class="color-container" (click)="updateTheme('purple-theme')">
                                    <div class="colorDiv color-purple"></div>
                                </div>
                            </div>
                            <div class="col-sm-6 hover-effect" data-toggle="tooltip" data-placement="bottom" title="Blue Theme"
                                style="padding: 0;">
                                <div class="color-container" (click)="updateTheme('blue-theme')">
                                    <div class="colorDiv color-blue"></div>
                                </div>
                            </div>
                        </div>
                        <div class="row p-2" style="margin: 0;">
                            <div class="col-sm hover-effect" data-toggle="tooltip" data-placement="bottom" title="Red Theme"
                                style="padding: 0;">
                                <div class="color-container">
                                    <div class="colorDiv color-red" (click)="updateTheme('red-theme')"></div>
                                </div>
                            </div>
                            <div class="col-sm hover-effect" data-toggle="tooltip" data-placement="bottom" title="Violet Theme"
                                style="padding: 0;">
                                <div class="color-container">
                                    <div class="colorDiv color-violet" (click)="updateTheme('violet-theme')"></div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>                
            </div>
        </div>
    </div>
</div>

<!-- <h1 mat-dialog-title>{{this.translate.data["SUBTITLESETTINGS"] | translate}}</h1>
<div mat-dialog-content>
    <div class="row">
        <div class="col-md-6">
            <mat-form-field class="form-element">
                <mat-label>{{this.translate.data["SELECTLANGUAGE"] | translate}}</mat-label>
                <mat-select>
                    <mat-option *ngFor="let lang of appLanguages" [value]="lang.abbv" (click)="setLang(lang.abbv)">
                        {{lang.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-md-6">
            <fieldset class="div-colors">
                <legend>{{this.translate.data["SELECTCOLORTHEME"] | translate}}</legend>
                <div class="row p-2" style="margin: 0;">
                    <div class="col-sm-6 hover-effect" data-toggle="tooltip" data-placement="bottom"
                        title="Purple Theme" style="padding: 0;">
                        <div class="color-container" (click)="updateTheme('purple-theme')">
                            <div class="colorDiv color-purple"></div>
                        </div>
                    </div>
                    <div class="col-sm-6 hover-effect" data-toggle="tooltip" data-placement="bottom" title="Blue Theme"
                        style="padding: 0;">
                        <div class="color-container" (click)="updateTheme('blue-theme')">
                            <div class="colorDiv color-blue"></div>
                        </div>
                    </div>
                </div>
                <div class="row p-2" style="margin: 0;">
                    <div class="col-sm hover-effect" data-toggle="tooltip" data-placement="bottom" title="Red Theme"
                        style="padding: 0;">
                        <div class="color-container">
                            <div class="colorDiv color-red" (click)="updateTheme('red-theme')"></div>
                        </div>
                    </div>
                    <div class="col-sm hover-effect" data-toggle="tooltip" data-placement="bottom" title="Violet Theme"
                        style="padding: 0;">
                        <div class="color-container">
                            <div class="colorDiv color-violet" (click)="updateTheme('violet-theme')"></div>
                        </div>
                    </div>
                </div>
            </fieldset>
        </div>
    </div>
</div> -->